
function getFirstAndLastInitials(text) {
    if (!text) return "";

    const words = text.trim().split(/\s+/);

    if (words.length === 1) {
        return words[0].charAt(0).toUpperCase();
    }

    const firstInitial = words[0].charAt(0).toUpperCase();
    const lastInitial = words[words.length - 1].charAt(0).toUpperCase();

    return `${firstInitial}${lastInitial}`;
}


export const UserBadge = (text, label="", size = 8,textSize="sm" )  => {

    return (
        <span className={"inline-flex shrink-0 size-"+size+" h-"+size+" w-"+size+" items-center justify-center rounded-full bg-gray-500"} title={label+" "+text}>
            <span className={"text-"+textSize+" shrink-0  font-medium text-gray-900"}>{getFirstAndLastInitials(text)}</span>
          </span>
    );
}

export const CompanyBadge = (text, size = 8,textSize="sm", isActive = false )  => {
    return (
        <span className={`inline-flex shrink-0 size-${size} h-${size} w-${size} items-center justify-center rounded-full ${isActive ? 'bg-gray-900' : 'bg-gray-300'}`} title={text}>
            <span className={`text-[10px] shrink-0 font-medium ${isActive ? 'text-gray-200' : 'text-gray-900'}`}>{text !== ' ' ? text?.slice(0,4) : '...'}</span>
          </span>
    );
}